import React from "react";
import { Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import PageHeader from "../../../components/PageHeader";
import { Link } from "react-router-dom";
import WarehousesTable from "../../../components/Tables/WarehousesTable";
import {withRouter} from "react-router-dom";
import withPermissions from "../../../components/WithPermissions";
import ManagementPageHero from "../../../components/ManagementPageHero";

class Warehouses extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const {userPermissions} = this.props;
    const userHasCreatePermission = userPermissions.includes('warehouse.create');

    return (
      <div
        className="management-page"
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Depolar"
                Breadcrumb={[
                  {name: "Stok Yönetimi", navigate: ""},
                  {name: "Depolar", navigate: ""},
                ]}
            />
            <ManagementPageHero
              eyebrow="DEPO YÖNETİMİ"
              title="Depolarınızı tek merkezden yönetin"
              description="Depo tanımlarını ve ilişkili stok durumlarını düzenli biçimde takip edin."
              actionTo={userHasCreatePermission ? "/stock/warehouse-add" : null}
              actionLabel="Yeni depo"
            />
            <div className="row clearfix">
              <div className="col-lg-12 col-md-12">
                <div className="card planned_task management-list-card">
                  <div className="header">
                    <h2>Depolar</h2>
                    {userHasCreatePermission ? (
                        <Dropdown as="ul" className="header-dropdown">
                          <Dropdown.Toggle
                              variant="success"
                              as="li"
                              id="dropdown-basic"
                          >
                            <i className="icon-plus text-success p-1 ml-1"></i>
                            <Dropdown.Menu
                                as="ul"
                                className="dropdown-menu dropdown-menu-right"
                            >
                              <li>
                                <Link to="/stock/warehouse-add">Yeni Depo</Link>
                              </li>
                            </Dropdown.Menu>
                          </Dropdown.Toggle>
                        </Dropdown>
                    ) : ""}
                  </div>
                  <div className="body">
                    <WarehousesTable />
                  </div>
                </div>
              </div>
            </div>
            <style>
              {`
                #dropdown-basic::after {
                    display: none;                                                     
                }
              `}
            </style>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({stockReducer}) => ({
  warehouses: stockReducer.warehouses,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(Warehouses)));
